import { Box, CircularProgress } from "@mui/material"

const LoadingSection = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '500px', justifyContent: 'center', alignItems: 'center' }}>
      <Box>
        <CircularProgress size="3rem" />
      </Box>
      <Box sx={{ fontWeight: 'bold', mt: 1 }}>Loading...</Box>
    </Box>
  )
}

export default LoadingSection;